import { actionCreator } from '@/utils/redux/action-creator';


const creator = actionCreator('AUTH');

export const AuthAction = {
  Registration:   creator.asyncAction('REGISTER_USER')
};
